import { faDownload, faTrash } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { ReactNode } from "react";

export const FileItemDisplay = (props: {
    filename: string;
    extraInfo?: string | ReactNode;
    error?: string;
    downloadUrl?: string;
    scanComplete: boolean;
    virusDetected: boolean;
    onDelete: () => void;
    readonly?: boolean;
}) => (
    <div
        className={`
        w-full px-4 py-2 border rounded 
        font-sm flex items-center justify-between
        ${props.error || props.virusDetected ? "border-red-500" : ""}
    `}
    >
        <div className="max-w-52 overflow-hidden">
            <span className="line-clamp-2" title={props.filename}>
                {props.filename}
            </span>
            {!props.error && props.extraInfo && (
                <span className="text-neutral-400">{props.extraInfo}</span>
            )}
            {(props.error || props.virusDetected) && (
                <span className="text-red-500">
                    {props.error || "File flagged as infected by AV."}
                </span>
            )}
        </div>
        <div className="flex gap-2">
            {!props.readonly && (
                <button type="button" onClick={props.onDelete}>
                    <FontAwesomeIcon icon={faTrash} className="w-4" />
                </button>
            )}
            {props.scanComplete &&
                !props.virusDetected &&
                props.downloadUrl && (
                    <button
                        type="button"
                        onClick={() => {
                            window.open(props.downloadUrl, "_blank");
                        }}
                    >
                        <FontAwesomeIcon icon={faDownload} className="w-4" />
                    </button>
                )}
        </div>
    </div>
);
